/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { RoleLightDto } from './RoleLightDto';
import {
    RoleLightDtoFromJSON,
    RoleLightDtoFromJSONTyped,
    RoleLightDtoToJSON,
    RoleLightDtoToJSONTyped,
} from './RoleLightDto';

/**
 * 
 * @export
 * @interface FindRoleResponseDto
 */
export interface FindRoleResponseDto {
    /**
     * List of roles
     * @type {Array<RoleLightDto>}
     * @memberof FindRoleResponseDto
     */
    items: Array<RoleLightDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof FindRoleResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the FindRoleResponseDto interface.
 */
export function instanceOfFindRoleResponseDto(value: object): value is FindRoleResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function FindRoleResponseDtoFromJSON(json: any): FindRoleResponseDto {
    return FindRoleResponseDtoFromJSONTyped(json, false);
}

export function FindRoleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindRoleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RoleLightDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function FindRoleResponseDtoToJSON(json: any): FindRoleResponseDto {
    return FindRoleResponseDtoToJSONTyped(json, false);
}

export function FindRoleResponseDtoToJSONTyped(value?: FindRoleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(RoleLightDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

